import { termosStep } from '../../shared/termosSections';

const pedidoComissoesEstagiarioConfig = {
  id: 'pedido_comissoes_estagiario',
  nome: 'Inscrições para Comissões OAB/MS (TIPO - ESTAGIÁRIO)',
  categoria: 'comissoes',
  descricao: 'Inscrição de estagiários(as) na Comissão de Estágio da OAB/MS',
  icon: 'FaGavel',
  // Só pode enviar se não estiver inadimplente com a OAB (ver oabData.isInadimplente
  // no login) — checado em DynamicPedidoPage.js, que mostra uma mensagem explicando
  // o motivo em vez de simplesmente esconder o pedido da listagem.
  bloqueiaInadimplente: true,

  documentConfig: {
    required: []
  },

  paymentConfig: {
    amount: 0
  },

  protocoloConfig: {
    modeloRequerimento: '266',
    tiposAssunto: '754',
    departamentoDestino: '67',
    tipoPedido: '456'
  },

  // Confirmado ao vivo contra GET /modelo-requerimento/266/campos (mesmo shape
  // do pedido de Comissões Advogado, sem o campo de comissão).
  dadosRequerimentoConfig: {
    campos: [
      { field: 'nomeCompleto', campoNome: 'Nome' },
      { field: 'numeroOAB', campoNome: 'RegistroConselhoOrigem' },
      { field: 'celular', campoNome: 'TelefoneCelular' },
      { field: 'email', campoNome: 'EmailResidencial' }
    ]
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { type: 'text', name: 'nomeCompleto', label: 'Nome completo', required: true, placeholder: 'Digite seu nome completo' },
            { type: 'text', name: 'numeroOAB', label: 'Número da OAB', required: true, placeholder: 'Nº de inscrição na OAB' },
            { type: 'phone', name: 'celular', label: 'Celular', required: true },
            { type: 'email', name: 'email', label: 'E-mail', required: true, placeholder: 'email@exemplo.com' }
          ]
        }
      ]
    },
    termosStep()
  ]
};

export default pedidoComissoesEstagiarioConfig;
